const getters = {
    hasPendingLegalDocuments: (state) => state.pendingLegalDocuments.length > 0
};

export default getters;
